export function classNames(...args) {
    return args
        .flat()
        .filter(Boolean) // حذف undefined یا false یا null
        .join(" ");
}
